/* SoCal Va'a — desktop nav stabilizer.
   Horizon's header menu hydrates from low-priority modules and slots items into
   a "More" overflow from a one-shot layout measurement. Both are timing-sensitive:
   hover before hydration does nothing, and a measure taken before fonts/layout
   settle can hide items (or flip the menu into drawer mode via minimum-reached).
   This guard re-measures once conditions are stable and re-fires hovers that
   landed in the dead window. It never blocks or replaces the theme's own logic. */
(function () {
  /* 1. Re-slot the top-level items once real metrics exist. <overflow-list>
        listens for a 'reflow' CustomEvent and re-runs its measurement. */
  function kickReflow() {
    try {
      document.querySelectorAll('header-menu overflow-list').forEach(function (ol) {
        ol.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
      });
    } catch (e) {}
  }
  function scheduleKicks() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { requestAnimationFrame(kickReflow); });
    }
    if (document.readyState === 'complete') setTimeout(kickReflow, 0);
    else window.addEventListener('load', function () { setTimeout(kickReflow, 0); }, { once: true });
    setTimeout(kickReflow, 2500); /* late safety net for slow font/asset arrivals */
  }
  if (customElements.get('overflow-list')) scheduleKicks();
  else customElements.whenDefined('overflow-list').then(scheduleKicks);

  /* 2. If the pointer is already parked on a menu item when the header-menu
        component finally defines, replay the hover so the dropdown opens
        instead of staying dead until the pointer moves away and back. */
  customElements.whenDefined('header-menu').then(function () {
    requestAnimationFrame(function () {
      try {
        var li = document.querySelector('header-menu .menu-list__list-item:hover');
        if (li && !li.querySelector('[aria-expanded="true"]')) {
          li.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
        }
      } catch (e) {}
    });
  });

  /* 3. Watchdog: a real hover on an item with a submenu that still hasn't
        expanded 300ms later gets replayed once. Covers listeners lost to
        DOM morphs. Trusted events only, so our own synthetic replay (and the
        theme's Safari-reconcile replays) never loop. */
  document.addEventListener(
    'pointerenter',
    function (ev) {
      var t = ev.target;
      if (!ev.isTrusted || !(t instanceof Element)) return;
      if (!t.matches('header-menu .menu-list__list-item')) return;
      if (!t.querySelector('[ref="submenu[]"]')) return;
      setTimeout(function () {
        try {
          if (!t.matches(':hover')) return;
          var link = t.querySelector('[ref="menuitem"]');
          if (link && link.getAttribute('aria-expanded') !== 'true') {
            t.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
          }
        } catch (e) {}
      }, 300);
    },
    true
  );
})();

/* 4. Hover retention: Horizon's delegated /deactivate also fires for pointer
   crossings that never leave the hovered item's subtree — anchor → li padding
   (closes, then Horizon's reconcile reopens ~90ms later: visible flicker) and
   li → open mega-menu panel (the panel collapses under the cursor and nothing
   reopens it — the menu dies exactly as you try to enter it). Its safety box
   only exists while the pointer is moving; a 50ms pause collapses it, so slow
   or diagonal entries lose the menu. Swallow precisely those internal
   crossings at window capture (runs before any theme listener). External
   leaves — to another nav item, or off the menu — pass through untouched, so
   switching and closing behave exactly as before. */
(function () {
  if (window.__svNavLeaveFix) return;
  window.__svNavLeaveFix = 1;
  window.addEventListener(
    'pointerleave',
    function (ev) {
      var t = ev.target;
      if (!(t instanceof Element) || !t.closest) return;
      var li = t.closest('header-menu .menu-list__list-item');
      if (!li) return;
      var rel = ev.relatedTarget;
      if (rel instanceof Element && li.contains(rel)) ev.stopImmediatePropagation();
    },
    true
  );
})();

/* iOS: focusing an input inside the cart drawer (the discount code box) makes
   Safari inflate the dialog's scrollable area to raise the keyboard, and the
   empty space persists after the keyboard closes. When any drawer input loses
   focus, snap the viewport back and clamp the drawer scroller. */
(function () {
  if (window.__svDrawerKbFix) return;
  window.__svDrawerKbFix = 1;
  document.addEventListener(
    'focusout',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.cart-drawer__content, .theme-drawer__dialog')) return;
      setTimeout(function () {
        window.scrollTo(window.scrollX, window.scrollY);
        document.querySelectorAll('.cart-drawer__content, .theme-drawer__dialog').forEach(function (c) {
          var max = Math.max(0, c.scrollHeight - c.clientHeight);
          if (c.scrollTop > max) c.scrollTop = max;
        });
      }, 250);
    },
    true
  );
})();

/* iOS back-forward cache restores pages with the cart drawer's HTML frozen at
   first render — stale totals/discounts vs the live cart ("different cart on
   different pages"). On bfcache restore, re-render the drawer section fresh. */
(function () {
  if (window.__svCartStaleFix) return;
  window.__svCartStaleFix = 1;
  var refresh = (window.__svRefreshCartDrawer = function () {
    var secEl = document.querySelector('[id^="shopify-section"][id*="cart-drawer"]');
    if (!secEl) return Promise.resolve(false);
    var secId = secEl.id.replace(/^shopify-section-/, '');
    return fetch('/?sections=' + encodeURIComponent(secId) + '&_fd=0&pb=0')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j[secId];
        if (!html) return false;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var fresh = tpl.content.firstElementChild;
        secEl.innerHTML = fresh && fresh.id === secEl.id ? fresh.innerHTML : html;
        return true;
      })
      .catch(function () { return false; });
  });
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) refresh();
  });
})();
